import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { useState } from "react";
import { btnCancel, label, modalTitle, title, btnOne } from "../utils/style";
import { toast } from "react-toastify";
import { returnDiscountedAmount } from "../helperFunctions/estimateCalculation"
import formatNumberToUs from "../custom_functions/formatNumberToUs";
import Modal from "../reusable_components/Modal";
import { FiBell, FiEye, FiTrash2 } from "react-icons/fi";
import warning from '../assets/icons/warning.png'
import axios from "axios";
import { setLoader } from "../reusable_components/Loader.js";

function FleetOpenEstimates() {
    const [showModal, setShowModal] = useState(false);
    const [workOrder, setWorkOrder] = useState(null);
    const [showDeletePop, setShowDeletePop] = useState(false)
    const [showDeleteAllPop, setShowDeleteAllPop] = useState(false)
    const [data, setData] = useState(null)
    const [reloadTable, setReloadTable] = useState(false)
    const [wrongEstimateId, setWrongEstimateId] = useState(null)

    const showDeleteOption = workOrder?.fleet_booking?.bypassApproval === "yes" ? true : (workOrder?.status !== "Pending" && workOrder?.status !== "Approved") ? true : false;

    const handleEyeClick = (data) => {
        setShowModal(true);
        setWorkOrder(data)
    };

    async function deleteServiceItem() {
        try {
            setLoader(true);
            const reqUrl = url + `/open_fleet_work_estimates/${workOrder.id}`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data: response } = await axios.patch(reqUrl, data, { headers });
            setWorkOrder(response.result)
            setReloadTable((prev) => !prev);
            toast.success(response.message, { autoClose: 3000 })
        } catch (e) {
            toast.error("Something went wrong", { autoClose: 3000 })
        } finally {
            setLoader(false);
            setShowDeletePop(false)
        }
    }

    async function handleResendEstimate(workOrder) {
        try {
            setLoader(true);
            const reqUrl = url + `/estimate_reminder`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data: response } = await axios.post(reqUrl, { signwellId: workOrder.signwell_id }, { headers });
            toast.success(response.message, { autoClose: 3000 })
        } catch (e) {
            toast.error("Something went wrong", { autoClose: 3000 })
        } finally {
            setLoader(false);
        }
    }

    async function cancelBooking(workOrder) {
        try {
            setLoader(true);
            const reqUrl = url + `/cancel_fleet_booking/${workOrder.fleet_booking.id}`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data: response } = await axios.delete(reqUrl, { headers });
            toast.success(response.message, { autoClose: 3000 })
            setShowModal(false)
            setReloadTable((prev) => !prev);
        } catch (e) {
            toast.error("Something went wrong", { autoClose: 3000 })
        } finally {
            setLoader(false);
        }
    }



    function deleteService(bundle, serviceType) {
        setShowDeletePop(true)
        setData({ item: bundle, itemType: serviceType, taxRatePercent: Number(workOrder.fleet_booking.taxRatePercent), technicianCostPerHour: Number(workOrder.fleet_booking.technicianHourlyCost) })
    }

    async function deleteWholeEstimate() {
        try {
            setLoader(true);
            const reqUrl = url + `/open_fleet_work_estimates/${wrongEstimateId}`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data: response } = await axios.delete(reqUrl, { headers });
            setShowModal(false)
            setReloadTable((prev) => !prev);
            toast.success(response.message, { autoClose: 3000 })
        } catch (e) {
            toast.error("Something went wrong", { autoClose: 3000 })
        } finally {
            setLoader(false);
            setShowDeleteAllPop(false)
        }
    }

    const options = [
        {
            header: "Work Order Id",
            key: "id",
            width: "10%",
        },
        {
            header: "Bypass Approval",
            key: "bypassApproval",
            width: "10%",
            render: (data => { return data.fleet_booking.bypassApproval === "yes" ? "Yes" : "No" })
        },
        {
            header: "Booking Id",
            key: "fleet_booking",
            width: "10%",
            render: (data => { return `FAP000${data.fleet_booking.id}` })
        },
        {
            header: 'Customer',
            key: "fleet_booking.fleet_customer.name",
            width: "10%",
            render: (data) => { return data.fleet_booking.fleet_customer.name },
        },
        {
            header: 'Status',
            key: 'status',
            width: "10%",
            render: (data) => {
                let colorClass = "";

                switch (data.status) {
                    case "Pending":
                        colorClass = "text-yellow-500 font-semibold";
                        break;
                    case "Rejected":
                        colorClass = "text-red-500 font-semibold";
                        break;
                    case "Approved":
                        colorClass = "text-green-500 font-semibold";
                        break;
                    default:
                        colorClass = "text-blue-500 font-semibold";
                        break;
                }

                return <span className={colorClass}>{data.status}</span>;
            },
        },
        {
            header: 'Tax',
            key: 'tax',
            width: "10%",
            render: (data) => { return data.tax === 0 ? "$0.00" : `$${formatNumberToUs(data.tax)}` },
        },
        {
            header: 'Total',
            key: 'totalCostFinal',
            width: "10%",
            render: (data) => { return data.totalCostFinal === 0 ? "$0.00" : `$${formatNumberToUs(data.totalCostFinal)}` },
        },
        {
            header: "Expiry Date",
            key: "estimatedExpirationDate",
            width: "10%",
            render: (data) => {
                if (!data.estimatedExpirationDate) {
                    return ""
                }
                const date = new Date(data.estimatedExpirationDate);
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();
                return <div className="truncate whitespace-nowrap">{`${month}-${day}-${year}`}</div>;
            },
        },
        {
            header: 'Action',
            width: "10%",
            render: (data) => <FiEye className='text-blue-600 cursor-pointer ml-4' onClick={() => handleEyeClick(data)} />,
        }
    ]

    const excludeFilter = ["Booking Id", "Bypass Approval", "Action", "Subtotal", "Tax", "Total", "Expiry Date"]


    return (
        <div className="overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Fleet Open Estimates</div>
            </div>

            {showDeletePop &&
                <div className="flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-screen w-screen bg-opacity-60 z-40">
                    <div className="bg-white w-1/3 px-8 pt-8 pb-4 rounded-lg">
                        <div className={modalTitle}>{`Delete`}</div>
                        <div className="flex gap-2 items-center py-6">
                            <img src={warning} height={25} width={25} />
                            <div className="text-center">{`Are you sure you want to delete this item?`}</div>
                        </div>
                        <div className="flex justify-between py-3 px-16 gap-8">
                            <button onClick={(e) => setShowDeletePop(false)} className={btnCancel}>Cancel</button>
                            <button onClick={(e) => deleteServiceItem()} className={btnOne}>Submit</button>
                        </div>
                    </div>
                </div>
            }
            {showDeleteAllPop &&
                <div className="flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-screen w-screen bg-opacity-60 z-40">
                    <div className="bg-white w-1/3 px-8 pt-8 pb-4 rounded-lg">
                        <div className={modalTitle}>{`Delete`}</div>
                        <div className="flex gap-2 items-center py-6">
                            <img src={warning} height={25} width={25} />
                            <div className="text-center">{`Are you sure you want to delete whole estimate?`}</div>
                        </div>
                        <div className="flex justify-between py-3 px-16 gap-8">
                            <button onClick={(e) => setShowDeleteAllPop(false)} className={btnCancel}>Cancel</button>
                            <button onClick={(e) => deleteWholeEstimate()} className={btnOne}>Submit</button>
                        </div>
                    </div>
                </div>
            }
            {
                showModal &&
                <Modal setShowModal={setShowModal}
                    component={() => (
                        (workOrder.bundleList?.data.length > 0 || workOrder.serviceList?.data.length > 0 || workOrder.materialList?.data.length > 0 || workOrder.otherList?.data.length > 0) ? (
                            <div className='text-sm m-2 max-h-80 overflow-y-auto'>

                                <div className="text-center text-lg font-semibold">Work Order #{workOrder.id}</div>
                                <div className="flex flex-row justify-between items-center mb-4 mt-2">
                                    {
                                        workOrder?.fleet_booking?.bypassApproval === "no" && workOrder.status === "Pending" && <button
                                            className="flex items-center gap-2 rounded-full bg-green-500 text-white px-4 py-2 transition-all shadow-sm"
                                            onClick={() => handleResendEstimate(workOrder)}>
                                            <FiBell className="text-lg" />
                                            Resend Estimate
                                        </button>
                                    }
                                    {
                                        workOrder?.fleet_booking?.bypassApproval === "no" && workOrder.status !== "Approved" &&
                                        <button
                                            className="flex items-center gap-2 rounded-full bg-red-500 text-white px-4 py-2 transition-all shadow-sm"
                                            onClick={() => cancelBooking(workOrder)}>
                                            <FiTrash2 className="text-lg" />
                                            Cancel Booking
                                        </button>
                                    }
                                    {
                                        showDeleteOption &&
                                        <button onClick={() => { setWrongEstimateId(workOrder.id); setShowDeleteAllPop(true) }}
                                            className={"flex items-center gap-2 rounded-full py-2 px-4 text-center text-sm text-white bg-customOne transition-all shadow-sm"}>
                                            <FiTrash2 className="text-lg" />
                                            Delete Estimate
                                        </button>
                                    }
                                </div>
                                {workOrder.bundleList?.data.length > 0 && <div className={label}>Service Bundle</div>}
                                {workOrder.bundleList?.data.map((bundle, ind) => (
                                    <div key={ind} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                                        <div className="flex justify-between items-start mb-2">
                                            <div className="font-bold text-gray-700 truncate capitalize">{bundle.name}</div>
                                            {showDeleteOption && (
                                                <button
                                                    onClick={() => deleteService(bundle, 'bundleList')}
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    <FiTrash2 className="h-5 w-5" />
                                                </button>
                                            )}
                                        </div>

                                        <div className="grid grid-cols-2 gap-2 text-sm">
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Cost:</span>
                                                <span className="text-gray-700 font-bold">${formatNumberToUs(bundle.cost)}</span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discount:</span>
                                                <span className="text-gray-700 font-bold">
                                                    {bundle.discountType === 'flat' && '$'}{`${formatNumberToUs(bundle.discount)} (${bundle.discountType === 'flat' ? 'Flat' : '%'})`}
                                                </span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discounted Cost:</span>
                                                <span className="text-gray-700 font-bold">
                                                    ${formatNumberToUs(returnDiscountedAmount({ cost: bundle?.cost, discount: bundle?.discount, discountType: bundle?.discountType }))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}


                                {workOrder.serviceList?.data.length > 0 && <div className={`${label} mt-2`}>Service List</div>}
                                {workOrder.serviceList?.data.map((service, ind) => (
                                    <div key={ind} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                                        <div className="flex justify-between items-start mb-2">
                                            <div className="font-bold text-gray-700 truncate capitalize">{service.name}</div>
                                            {showDeleteOption && (
                                                <button
                                                    onClick={() => deleteService(service, 'serviceList')}
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    <FiTrash2 className="h-5 w-5" />
                                                </button>
                                            )}
                                        </div>

                                        <div className="grid grid-cols-2 gap-2 text-sm">
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">{service.costType === 'Fixed' ? 'Cost:' : 'Time:'}</span>
                                                <span className="text-gray-700 font-bold">
                                                    {service.costType === 'Fixed' && '$'}{service.estimatedTime || service.estimatedCost} {service.costType === 'Hourly' && 'mins'}
                                                </span>
                                            </div>
                                            {
                                                service.costType !== 'Fixed' &&
                                                <div className="flex items-center">
                                                    <span className="text-gray-500 mr-2">Cost:</span>
                                                    <span className="text-gray-700 font-bold">
                                                        ${formatNumberToUs(((service.estimatedTime / 60) * workOrder.fleet_booking.technicianHourlyCost).toFixed(2))}
                                                    </span>
                                                </div>
                                            }
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discount:</span>
                                                <span className="text-gray-700 font-bold">
                                                    {service.discountType === 'flat' && '$'}{`${formatNumberToUs(service.discount)} (${service.discountType === 'flat' ? 'Flat' : '%'})`}
                                                </span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discounted Cost:</span>
                                                <span className="text-gray-700 font-bold">
                                                    ${formatNumberToUs(returnDiscountedAmount({ cost: service.estimatedTime ? ((service.estimatedTime / 60) * workOrder.fleet_booking.technicianHourlyCost).toFixed(2) : service.estimatedCost, discount: service?.discount, discountType: service?.discountType }))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}


                                {workOrder.materialList?.data.length > 0 && <div className={`${label} mt-2`}>Part List</div>}
                                {workOrder.materialList?.data.map((material, ind) => (
                                    <div key={ind} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                                        <div className="flex justify-between items-start mb-2">
                                            <div className="font-bold capitalize text-gray-700 truncate">{material.name}</div>
                                            {showDeleteOption && (
                                                <button
                                                    onClick={() => deleteService(material, 'materialList')}
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    <FiTrash2 className="h-5 w-5" />
                                                </button>
                                            )}
                                        </div>
                                        <div className="grid grid-cols-2 gap-2 text-sm">
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Time:</span>
                                                <span className="text-gray-700 font-semibold">{material.estimatedTime} mins</span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Cost:</span>
                                                <span className="text-gray-700 font-semibold">${formatNumberToUs(material.cost)}</span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Sales Tax:</span>
                                                <span className="text-gray-700 font-semibold">{workOrder.fleet_booking.taxRatePercent}%</span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discount:</span>
                                                <span className="text-gray-700 font-bold">
                                                    {material.discountType === 'flat' && '$'}{`${formatNumberToUs(material.discount)} (${material.discountType === 'flat' ? 'Flat' : '%'})`}
                                                </span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discounted Cost:</span>
                                                <span className="text-gray-700 font-bold">
                                                    ${formatNumberToUs(returnDiscountedAmount({ cost: material?.cost, discount: material?.discount, discountType: material?.discountType }))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}


                                {workOrder.otherList?.data.length > 0 && <div className={`${label} mt-2`}>Other List</div>}
                                {workOrder.otherList?.data.map((other, ind) => (
                                    <div key={ind} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                                        <div className="flex justify-between items-start mb-2">
                                            <div className="font-bold text-gray-700 truncate capitalize">{other.name}</div>
                                            {showDeleteOption && (
                                                <button
                                                    onClick={() => deleteService(other, 'otherList')}
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    <FiTrash2 className="h-5 w-5" />
                                                </button>
                                            )}
                                        </div>
                                        <div className="grid grid-cols-2 gap-2 text-sm">
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Time:</span>
                                                <span className="text-gray-700 font-bold">{other.estimatedTime} mins</span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Cost:</span>
                                                <span className="text-gray-700 font-bold">
                                                    ${formatNumberToUs(((other.estimatedTime / 60) * workOrder.fleet_booking.technicianHourlyCost).toFixed(2))}
                                                </span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discount:</span>
                                                <span className="text-gray-700 font-bold">
                                                    {other.discountType === 'flat' && '$'}{`${formatNumberToUs(other.discount)} (${other.discountType === 'flat' ? 'Flat' : '%'})`}
                                                </span>
                                            </div>
                                            <div className="flex items-center">
                                                <span className="text-gray-500 mr-2">Discounted Cost:</span>
                                                <span className="text-gray-700 font-bold">
                                                    ${formatNumberToUs(returnDiscountedAmount({ cost: ((other.estimatedTime / 60) * workOrder.fleet_booking.technicianHourlyCost).toFixed(2), discount: other?.discount, discountType: other?.discountType }))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}


                            </div>
                        ) : (<div className="text-center p-10">No items in this estimate.</div>)
                    )} />
            }
            <Table
                className="max-h-[80vh] overflow-y-auto"
                options={options}
                url={url + '/open_fleet_work_estimates'}
                pagination
                btnTitle='Manager'
                reloadTable={reloadTable}
                noButton={true}
                excludeFilter={excludeFilter}
            />
        </div >
    )
}

export default FleetOpenEstimates;